import { Action, Module, Mutation,
  VuexModule } from 'vuex-module-decorators';
import { page, sendBusinessRequests } from '@/services/api';
import { IBusinessPage, IPageBusinessTranslation } from '@/types';

const SET_BUSINESS_TRANSLATION = 'SET_BUSINESS_TRANSLATION';

const rawError: boolean = true;

@Module({namespaced: true})
export default class BusinessPage extends VuexModule implements IBusinessPage {
  public translation: IPageBusinessTranslation = {
    banner: {},
    form: {},
    thank_you_popup: {},
  };

  public get banner(): {} {
    return this.translation.banner;
  }

  public get formTexts(): {} {
    return this.translation.form;
  }

  public get popupTexts(): {} {
    return this.translation.thank_you_popup;
  }

  @Mutation
  public [SET_BUSINESS_TRANSLATION](payload: IPageBusinessTranslation): void {
    this.translation = payload;
  }

  @Action({commit: SET_BUSINESS_TRANSLATION, rawError})
  public async fetchTranslation() {
    const data = await page('to_business');
    return data ? data : this.translation;
  }

  @Action
  public async sendData(data) {
    const request = sendBusinessRequests(data);
    return request;
  }

}
